// @flow

import React from 'react'

import { UserModal } from 'src/common/components'
import { CloseIcon } from 'src/assets/icons'

// types
import type { ConfirmPropsType, ConfirmStateType } from './ConfirmTypes'

export default class ConfirmStatusChange extends React.Component<ConfirmPropsType, ConfirmStateType> {
  state = {
    open: false,
    callback: () => {},
    cancelCallback: () => {},
    hideCallback: () => {},
  }

  show = ({ valid, handleSubmit, handleCancel, handleHide, getDescriptionVariable }: {
      valid: boolean,
      handleSubmit: () => void,
      handleCancel: () => void,
      handleHide: () => void,
    getDescriptionVariable: () => void
  }) => (event: SyntheticInputEvent<HTMLInputElement>) => {
    if (event) {
      event.preventDefault()
    }
    getDescriptionVariable && getDescriptionVariable()

    !valid && handleSubmit()

    valid && this.setState({
      open: true,
      callback: () => handleSubmit(),
      cancelCallback: () => typeof handleCancel === 'function' ? handleCancel() : undefined,
      hideCallback: () => typeof handleHide === 'function' ? handleHide() : undefined,
    })
  }

  cancel = () => {
    this.state.cancelCallback()
    this.hide()
  }

  hide = () => {
    this.state.hideCallback()
    this.setState({
      open: false,
      callback: () => {},
      cancelCallback: () => {},
      hideCallback: () => {},
    })
  }

  confirm = () => {
    this.state.callback()
    this.hide()
  }

  render() {
    const confirmBtnText = this.props.confirmText || (this.props.closedQuestion ? 'Yes' : 'Ok')
    const cancelBtnText = this.props.cancelText || (this.props.closedQuestion ? 'No' : 'Cancel')

    return (
      <React.Fragment>
        {this.props.children(this.show)}

        {this.state.open && (
          <UserModal
            title={this.props.title}
            subtitle={this.props.description}
            onCancel={this.cancel}
            onConfirm={this.confirm}
            onHide={this.hide}
            showHideBtn={this.props.showHideBtn}
            showCancelBtn={this.props.showCancelBtn}
            showConfirmBtn={this.props.showConfirmBtn}
            confirmBtnText={confirmBtnText}
            cancelBtnText={cancelBtnText}
            cancelBtnPrependContent={this.props.isDeleting ? <CloseIcon/> : null}
            isCancelInPlainStyle={this.props.isDeleting}
          />
        )}
      </React.Fragment>
    )
  }
}
